module.exports = __webpack_public_path__ + "static/img/aqzs35.a07a8711.jpg";